"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var TabsButton = function TabsButton(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["active", "children", "className"]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])(classes.Tab, active && classes.ActiveTab, className)
  }), children);
};

exports["default"] = TabsButton;
//# sourceMappingURL=index.js.map